import {AbsFunction} from './abs-function';
import {RoundFunction} from './round-function';
import {CeilingFunction} from './ceiling-function';
import {FloorFunction} from './floor-function';
import {DifferenceFunction} from './difference-function';
import {Injectable} from '@angular/core';
import {AverageFunction} from './average-function';
import {MaximumFunction} from './maximum-function';
import {SumFunction} from './sum-function';
import {MinimumFunction} from './minimum-function';
import {AccumulatingChartFunction, ChartFunction, FunctionName, isAccumulatingChartFunction} from './chart-function-types';

@Injectable({
  providedIn: 'root',
})
export class ChartFunctionService {
  private funMap: Map<FunctionName, ChartFunction>;

  constructor() {
    this.funMap = new Map<FunctionName, ChartFunction>([
      [FunctionName.ABS, new AbsFunction()],
      [FunctionName.CEL, new CeilingFunction()],
      [FunctionName.FLR, new FloorFunction()],
      [FunctionName.RND, new RoundFunction()],
      [FunctionName.DIF, new DifferenceFunction()],
      [FunctionName.AVG, new AverageFunction()],
      [FunctionName.MIN, new MinimumFunction()],
      [FunctionName.MAX, new MaximumFunction()],
      [FunctionName.SUM, new SumFunction()],
    ]);
  }

  public getFunction(functionName: FunctionName): ChartFunction {
    return this.funMap.get(functionName);
  }

  public getAllFunctions(): ChartFunction[] {
    return Array.from(this.funMap.values());
  }

  public getAggregationFunction(functionName: FunctionName): AccumulatingChartFunction<unknown> {
    const aggregationFunction = this.getFunction(functionName);
    if (!isAccumulatingChartFunction(aggregationFunction)) {
      throw new Error('Expected an x axis aggregation function but got ' + functionName);
    }
    return aggregationFunction;
  }
}
